import { maybeEmpty } from "../../../../util";

export const createStringColumn = (getter, col) => {
  return {
    valueGetter: params => maybeEmpty(getter(params)).getOrElse(""),
    chartDataType: "category",
    allowedAggFuncs: ["first", "last"],
    filter: "agTextColumnFilter",
  };
};
